import { useEffect, useState } from "react";
import BErrorIndicator from "../../components/indicators/BErrorIndicator";
import BLoadingIndicator from "../../components/indicators/BLoadingIndicator";
import BResourcePage from "../../components/resources/BResourcePage";
import httpClient from "../../utilis/jwtRequest";

function StatisticsPage() {
  const [provincesStats, setProvincesStats] = useState([]);
  const [contractsNumber, setContractsNumber] = useState(0);
  const [estimationsNumber, setEstimationsNumber] = useState(0);
  const [verifiedEstimationsNumber, setVerifiedEstimationsNumber] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    setIsLoading(true);
    setError(false);
    httpClient
      .get("regions/stats/")
      .then((res) => {
        console.log(res);
        setVerifiedEstimationsNumber(res.data.verifiedEstimationsNumber);
        setEstimationsNumber(res.data.estimationsNumber);
        setContractsNumber(res.data.contractsNumber);
        setProvincesStats(res.data.regionStats);
      })
      .catch((err) => {
        console.log(err);
        setError(true);
      })
      .finally((_) => {
        setIsLoading(false);
      });
  }, []);

  if (isLoading) {
    return <BLoadingIndicator />;
  } else if (error) {
    return <BErrorIndicator />;
  }

  const aboveTableComponent = (
    <div className="text-gray-800 border-gray-800 border-b py-1 px-2 mr-10 space-x-8">
      <span className="text-sm font-semibold">Schätzungen:</span>{" "}
      {estimationsNumber}
      {"  "}
      <span className="text-sm font-semibold">Bestätigte Schätzungen:</span>{" "}
      {verifiedEstimationsNumber}
      {"  "}
      <span className="text-sm font-semibold">Vertragsnummer:</span>{" "}
      {contractsNumber}
      {"  "}
    </div>
  );

  return (
    <BResourcePage
      title={"Statistiken"}
      preloadedData={provincesStats}
      aboveTableComponent={aboveTableComponent}
      isReadOnly={true}
      fieldsVisibleAtBeginning={[
        "region",
        "housesEstimated",
        "apartmentEstimated",
        "parcelEstimated",
        "averagePropertyPrice",
        "intentionToSell10",
        "intentionToSell9",
      ]}
    />
  );
}

export default StatisticsPage;
